//:: NOTIFICATIONS
import miniToastr from "mini-toastr";

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
};
miniToastr.init({types: toastTypes});
function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}
export const notificationOptions = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};